import React from 'react';
import { Alert } from '@mui/material';

type Props = {
    isDisplayed: boolean;
    message: string;
    onClose: () => void;
};

const InscriptionAlert: React.FC<Props> = ({
    isDisplayed,
    message,
    onClose,
}) => (
    <>
        {isDisplayed ? (
            <Alert
                severity="info"
                onClose={onClose}
                sx={(theme) => ({
                    marginTop: '1rem',
                    alignItems: 'center',
                    backgroundColor: theme.palette.primary.background,
                })}
            >
                {message}
            </Alert>
        ) : null}
    </>
);

export default InscriptionAlert;
